module.exports = __webpack_public_path__ + "img/21.ad126c60.png";